import React from 'react';
const points = [{
  emoji: '😰',
  text: "L'ansia di arrivare in palestra senza sapere esattamente quale attività proporre oggi"
}, {
  emoji: '⏱️',
  text: 'Dover perdere ore a scrivere programmazioni che potresti risolvere in pochi minuti'
}, {
  emoji: '🤷',
  text: 'Emergenza pioggia o palestra occupata: ti blocchi quando devi restare in aula'
}, {
  emoji: '📊',
  text: 'Nessun criterio chiaro: non sai come valutare in modo oggettivo per la tua classe'
}, {
  emoji: '😓',
  text: 'Alunni demotivati che finiscono sempre per giocare "a palla prigioniera"'
}, {
  emoji: '😩',
  text: 'Domeniche sera rovinate per preparare le lezioni del lunedì mattina'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-99">
      <div className="max-w-3xl mx-auto" data-id="element-100">
        <div className="text-center mb-12" data-id="element-101">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-102">
            👉 Ti riconosci in queste situazioni?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-103">
            Se rispondi di sì a una di queste domande, questo pack è per te
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-104">
          {points.map((point, i) => <div key={i} className="flex items-center gap-4 sm:gap-6 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light shadow-sm" data-id="element-105">
              <div className="text-3xl sm:text-4xl flex-shrink-0" data-id="element-106">
                {point.emoji}
              </div>
              <p className="text-text-main font-medium text-base sm:text-lg leading-snug" data-id="element-107">
                {point.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-108">
          <p className="text-primary font-serif italic text-xl sm:text-2xl font-bold" data-id="element-109">
            Tu meriti di più… ed è qui che entra in gioco EDULABS →
          </p>
        </div>
      </div>
    </section>;
}